// Reviewsectie — filteren en meer laden. Zie snippets/product-reviews.liquid.
// Bewust zonder framework en zonder ophalen: alle reviews staan al in de HTML,
// dus filteren is tonen en verbergen. Werkt ook als dit script niet laadt —
// dan staan de eerste zes er gewoon en zijn de knoppen dood in plaats van stuk.
(function () {
  'use strict';

  var sectie = document.querySelector('.clr');
  if (!sectie) return;

  var lijst = sectie.querySelector('[data-clr-list]');
  var items = [].slice.call(sectie.querySelectorAll('[data-clr-review]'));
  var chips = [].slice.call(sectie.querySelectorAll('[data-clr-filter]'));
  var meer = sectie.querySelector('[data-clr-more]');
  if (!lijst || !items.length) return;

  // Hoeveel er zichtbaar zijn zonder "meer laden". Liquid heeft de rest al op
  // is-hidden gezet; dat getal lezen we hier terug in plaats van het te herhalen.
  var perKeer = items.filter(function (el) { return !el.classList.contains('is-hidden'); }).length || 6;
  var getoond = perKeer;
  var filter = 'all';

  function past(el) {
    if (filter === 'critical') return el.dataset.critical === 'true';
    if (filter === 'photo') return el.dataset.photo === 'true';
    return true;
  }

  function teken() {
    var n = 0;
    items.forEach(function (el) {
      if (!past(el)) { el.classList.add('is-hidden'); return; }
      n++;
      el.classList.toggle('is-hidden', n > getoond);
    });
    if (meer) meer.hidden = n <= getoond;
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      filter = chip.dataset.clrFilter;
      getoond = perKeer;           // een nieuw filter begint bovenaan
      chips.forEach(function (c) {
        var aan = c === chip;
        c.classList.toggle('is-on', aan);
        c.setAttribute('aria-pressed', aan ? 'true' : 'false');
      });
      teken();
    });
  });

  if (meer) {
    meer.addEventListener('click', function () {
      getoond += perKeer;
      teken();
      // Focus naar de eerste nieuw getoonde review, anders raakt een
      // toetsenbordgebruiker de draad kwijt na het klikken.
      var nieuw = items.filter(function (el) { return !el.classList.contains('is-hidden'); })[getoond - perKeer];
      if (nieuw) {
        nieuw.setAttribute('tabindex', '-1');
        nieuw.focus({ preventScroll: true });
      }
    });
  }

  teken();
})();
